import BrowserFeaturesPage from 'components/features-page/BrowserFeaturesPage'
import type { PageProps } from 'gatsby'

export default function Chrome({ location }: PageProps): JSX.Element {
  return <BrowserFeaturesPage path={location.pathname} />
}
